import { Loader } from "@googlemaps/js-api-loader"
import Store from '@/store/index.js';

const googleMapsApiLoader = new Loader({
  apiKey: Store.getters['account/googleMapsApiKey'],
  version: "weekly",
});

export default googleMapsApiLoader;